<template>
  <div>
    <form role='form'>
      <div class='modal-body'>
        <div class='alert alert-danger alert-dismissable' v-if='validationErrors'>
          <ul v-if='validationErrors'>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' v-if='successShow'>
          'تم تعديل الايصال بنجاح'
        </div>
        <fieldset>
          <div class='form-group col-lg-4 col-sm-4'>
            <label>الفرع:</label>
            <select class="form-control"  v-model="branch_id" >
              <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class='form-group col-lg-6 col-sm-6'>
            <label>رقم الايصال:</label>
            <input v-model='receiptID' v-on:keypress="GetDataKey($event)" class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-2 col-sm-2' style="padding-top: 23px">
            <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
            <button @click="GetData()" type='button' class='btn btn-primary btn-md btn-block'>عرض</button>
          </div>
          <div class='form-group col-lg-3 col-sm-3'>
            <label>الكود:</label>
            <input disabled v-model='record.rec_id' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-9 col-sm-9'>
            <label>الاسم:</label>
            <input disabled v-model='record.name' class='form-control' name='branchname' type='text'>
          </div>
          <div class='col-lg-3 col-sm-3' style='padding: 10px 10px 5px 10px;'>
            <span>غرض الاتصال:</span>
            <input disabled value='سداد قسط فلتر' class='form-control' name='notes' type='text'>
          </div>
          <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
            <span>حالة الاتصال:</span>
            <select class="form-control" style="padding: 0px" v-model="record.call_status_id">
              <option v-for="item in callStatus" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
            <span>الاجراء:</span>
            <select class="form-control" style="padding: 0px" v-model="record.action_id">
              <option v-for="item in actions" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class='form-group col-lg-3 col-sm-3'>
            <label>تاريخ الحافظة:</label>
            <input disabled v-model='record.folder_date' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-6 col-sm-6'>
            <label>ملاحظات الاتصال:</label>
            <input v-model='record.call_logs_notes'  @keyup='mirrorNotes()' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-6 col-sm-6'>
            <label>ملاحظات الفنى :</label>
            <input v-model='record.notes' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-3 col-sm-3'>
            <label>مدة التأجيل:</label>
            <input v-model='record.delay' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-2 col-sm-2'>
            <label>تاريخ القسط:</label>
            <input v-model='record.date' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-2 col-sm-2'>
            <label>المدفوع:</label>
            <input v-model='record.amount' @keyup='SetAmount()' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-2 col-sm-2'>
            <label>الباقى:</label>
            <input v-model='record.rest' @keyup='SetRest()' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-3 col-sm-3'>
            <label>م الصيانة:</label>
            <input disabled v-model='record.maintenance_expenses' class='form-control' name='branchname' type='text'>
          </div>
          <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
            <label>المدفوع:</label>
            {{record.amount_str}}
          </div>
          <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
            <label>البيان:</label>
            {{record.caption}}
          </div>
          <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
            <label>الباقى:</label>
            {{record.rest_str}}
          </div>
        </fieldset>
      </div>
      <div class='modal-footer'>
        <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
        <button @click='saveData()' type='button' class='btn btn-primary'>حفظ</button>
      </div>
    </form>
  </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
import tafqeet from '@/./assets/Tafqeet.js'
export default {
  components: {
    tbDate
  },
  name: 'AlterReceipt',
  data () {
    return {
      branches: {},
      branch_id: 0,
      receiptID: null,
      record: [],
      isLoadingData: false,
      validationErrors: null,
      successShow: null,
      callStatus: [],
      actions: [],
      types: [
        {id: 1, name: 'سداد قسط فلتر'},
        {id: 2, name: 'تغيير شمع وسداد'},
        {id: 3, name: 'عرض جديد'},
        {id: 4, name: 'طلب صيانة'}
      ],
      receiptsBranch_id: null,
      type_id: 0,
      emptyRec: [{id: 0, name: ''}],
      sort: 'cash_receipts.id',
      today: true,
      toTitle: 'إلى',
      folderDate: 'تاريخ الحافظة',
      fromTitle: 'من',
      from_date: '',
      to_date: '',
      folder_date: '',
      records: {},
      errorShow: false,
      isLoadingSave: false,
      CollectorsSuccess: '',
      CollectorsvalidationErrors: '',
      modelCollectors: {},
      collectors: {},
      CollectorRecords: [],
      collector_id: 0,
      modelCollectorId: '',
      cashReceipts: '',
      id: ''
    }
  },
  methods: {
    pageLoad () {
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      this.branch_id = JSON.parse(localStorage.getItem('BrancheID'))
    },
    // ======================================
    SetAmount () {
      if (this.record.amount > 0) {
        this.record.amount_str = '-مبلغ وقدره ' + this.record.amount + ' جنيه ' + tafqeet(this.record.amount) + ' جنيهاً فقط لا غير-'
      } else {
        this.record.amount_str = 'لا شيئ'
      }
    },
    // ======================================
    SetRest () {
      if (this.record.rest > 0) {
        this.record.rest_str = 'والمبلغ المتبقى ' + this.record.rest + 'ج فقط ' + tafqeet(this.record.rest) + ' جنيهاً لا غير'
      } else {
        this.record.rest_str = 'المبلغ المتبقى: صفر (لا توجد اى مبالغ متبقية)'
      }
    },
    // ========================================================
    mirrorNotes () {
      this.record.notes = this.record.call_logs_notes
    },
    // ======================================================
    GetDataKey (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 13) {
        this.GetData()
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45 && charCode !== 42) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // ======================================
    changeType () {
      if (this.record.type_id === 4) {
        this.record.caption = '............................................................................................ وذلك عن تنفيذ صيانة'
        this.record.rest_str = '.................................................................................................. و المبلغ المتبقى'
      }
    },
    // ======================================
    GetData () {
      this.isLoadingData = true
      this.successShow = false
      this.validationErrors = null
      axios.post(this.$apiURL + 'get-receipt-data', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        id: this.receiptID
      })
        .then(({ data }) => {
          this.record = data.Data
          this.actions = data.Actions
          this.callStatus = data.Status
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    // ===========================================================
    saveData () {
      this.isLoadingData = true
      this.successShow = false
      this.validationErrors = null
      axios.post(this.$apiURL + 'save-receipt-data', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        branch_id: this.branch_id,
        amount: this.record.amount,
        amount_str: this.record.amount_str,
        caption: this.record.caption,
        delay: this.record.delay,
        date: this.record.date,
        maintenance_expenses: this.record.maintenance_expenses,
        rest: this.record.rest,
        rest_str: this.record.rest_str,
        call_logs_notes: this.record.call_logs_notes,
        notes: this.record.notes,
        call_status_id: this.record.call_status_id,
        action_id: this.record.action_id
      })
        .then(res => {
          this.isLoadingData = false
          this.successShow = true
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/AlterReceipt.vue